import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Pages::Base @uwu={{this.uwu}} />",{ moduleName: "tpk-website/index/template.hbs" })